// A session's transcript is cumulative: the mobile app appends each new
// recording for the same patient to the previous transcript, and saves a new
// session (with its own checklist) for every recording. Each recording starts
// with a timestamp line written by kabilah-mobile-be's fetch_report as
// `${'%m/%d/%y %I:%M:%S %p %Z'} \n${text}\n\n`, e.g. "10/02/26 09:02:43 PM EDT ".
//
// The session's checklist is graded on its own recording only — the last one —
// so the AACN indicators must be too. The backend's grading paths apply the
// same rule (text after the last header line, trimmed); keep them in sync.
const RECORDING_HEADER = /^(\d{2}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2} [AP]M(?: \S+)?)[ \t]*$/gm;

// -> [{ recordedAt: '10/02/26 09:01:08 PM EDT' | null, text }] in order.
// A transcript with no header lines is one recording with recordedAt null.
export function splitRecordings(transcript) {
  const source = transcript || '';
  const headers = [...source.matchAll(RECORDING_HEADER)];
  if (headers.length === 0) {
    const text = source.trim();
    return text ? [{ recordedAt: null, text }] : [];
  }

  const recordings = [];
  const preamble = source.slice(0, headers[0].index).trim();
  if (preamble) recordings.push({ recordedAt: null, text: preamble });
  headers.forEach((match, i) => {
    const start = match.index + match[0].length;
    const end = i + 1 < headers.length ? headers[i + 1].index : source.length;
    recordings.push({ recordedAt: match[1], text: source.slice(start, end).trim() });
  });
  return recordings;
}

// The text of the recording this session was created for (its last one) —
// what its checklist evaluated and what its AACN indicators are graded on.
export function sessionRecordingText(transcript) {
  const recordings = splitRecordings(transcript);
  return recordings.length > 0 ? recordings[recordings.length - 1].text : '';
}
